import React from 'react';
import PropTypes from 'prop-types';
import IntlMessages from 'util/IntlMessages';
import styles from './PlaceholderSpinner.module.scss';

const PlaceholderSpinner = ({ height }) => {
  const effectiveHeight = height || 'calc(100vh - 200px)';
  const isCompact = typeof height === 'number' && height <= 180;

  return (
    <div
      className={`loader-view ${styles.root} ${isCompact ? styles.compact : ''}`}
      style={{ height: effectiveHeight }}
      role="status"
      aria-live="polite"
    >
      <span className={styles.srOnly}><IntlMessages id="common.loading" /></span>
      <div className={styles.content} aria-hidden="true">
        <div className={styles.indicator} />
        <div className={styles.skeleton}>
          <i />
          <i />
          <i />
        </div>
      </div>
    </div>
  );
};

PlaceholderSpinner.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PlaceholderSpinner.defaultProps = {
  height: null,
};

export default PlaceholderSpinner;
